import { Flex, Pill } from '@mantine/core';

import { InstPage, TgPage } from '@/features/pages';

type AppPagesCellProps = {
  pageIds?: string[];
  pagesMap: Map<string, TgPage | InstPage>;
};

export const AppPagesCell = ({ pageIds, pagesMap }: AppPagesCellProps) => {
  if (!pageIds?.length) {
    return null;
  }

  return (
    <Flex direction="column" gap={6}>
      {pageIds.map((pageId) => {
        const pageData = pagesMap.get(pageId);

        const label = pageData
          ? pageData.username
            ? `${pageData.name} (${pageData.username})`
            : pageData.name
          : pageId;

        return (
          <Pill key={`page-${pageId}`} bg="gray.8" size="sm" style={{ alignSelf: 'flex-start' }}>
            {label}
          </Pill>
        );
      })}
    </Flex>
  );
};
